export default __webpack_public_path__ + "static/media/qs_risk_free.0af8c983.png";